module.exports = __webpack_public_path__ + "img/sql.7f3943ff.png";